var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _polygon, _polygon2, _polygon3, _g, _g2, _g3, _path65, _path66, _g4, _path67, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _g5, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _g6, _g7, _g8, _path104, _g9, _g10, _rect, _rect2, _path105, _path106, _path107, _path108, _polygon18, _path109, _rect3, _path110, _path111, _path112, _path113, _path114, _rect4, _path115, _path116, _path117, _polygon19, _path118, _rect5, _path119, _path120, _path121, _path122, _path123, _path124;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPefoceOrgao({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 912.16 142.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-15,.cls-19,.cls-36,.cls-43{fill:none;}.cls-14,.cls-2{fill:#fff;}.cls-3{fill:#e9d5b0;}.cls-14,.cls-18,.cls-20,.cls-3,.cls-42{fill-rule:evenodd;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:url(#linear-gradient);}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{clip-path:url(#clip-path-3);}.cls-9{fill:url(#linear-gradient-3);}.cls-10{clip-path:url(#clip-path-4);}.cls-11{clip-path:url(#clip-path-5);}.cls-12{clip-path:url(#clip-path-6);}.cls-13{fill:url(#radial-gradient);}.cls-15{stroke:#fff;}.cls-15,.cls-19,.cls-36,.cls-43{stroke-miterlimit:2.61;stroke-width:0;}.cls-16{clip-path:url(#clip-path-7);}.cls-17{fill:url(#radial-gradient-2);}.cls-18{fill:#c9a42e;}.cls-19{stroke:#c9a42e;}.cls-20,.cls-35{fill:#f9c911;}.cls-21{clip-path:url(#clip-path-8);}.cls-22{clip-path:url(#clip-path-9);}.cls-23{fill:url(#linear-gradient-4);}.cls-24{clip-path:url(#clip-path-10);}.cls-25{clip-path:url(#clip-path-11);}.cls-26{fill:url(#linear-gradient-5);}.cls-27{clip-path:url(#clip-path-12);}.cls-28{clip-path:url(#clip-path-13);}.cls-29{fill:url(#linear-gradient-6);}.cls-30{clip-path:url(#clip-path-14);}.cls-31{clip-path:url(#clip-path-15);}.cls-32{fill:url(#linear-gradient-7);}.cls-33{clip-path:url(#clip-path-16);}.cls-34{fill:url(#linear-gradient-8);}.cls-36{stroke:#f9c911;}.cls-37{clip-path:url(#clip-path-18);}.cls-38{clip-path:url(#clip-path-19);}.cls-39{clip-path:url(#clip-path-20);}.cls-40{clip-path:url(#clip-path-21);}.cls-41{clip-path:url(#clip-path-22);}.cls-42{fill:#aa9176;}.cls-43{stroke:#aa9176;}.cls-44{fill:url(#linear-gradient-9);}.cls-45{fill:url(#linear-gradient-10);}.cls-46{fill:#6d4d32;}.cls-47{fill:#405864;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487.12,5.05,486,4.84c-1.83-.37-3.72-.74-5.52-1a.35.35,0,0,0-.29.08.36.36,0,0,0-.13.26l0,1.43,0,.86c-1.5-.21-2.91-.36-4.39-.51l-1.19-.13V3.38a.36.36,0,0,0-.33-.35c-2.12-.21-4.3-.38-6.48-.52a.35.35,0,0,0-.27.1.36.36,0,0,0-.11.26V5.26c-1.88-.08-3.81-.14-5.74-.18V2.65a.36.36,0,0,0-.36-.35h-2.68c-1.26,0-2.53,0-3.79,0a.36.36,0,0,0-.36.35V5.1c-1.88.05-3.8.11-5.74.2V2.9a.35.35,0,0,0-.11-.26.39.39,0,0,0-.27-.1c-2.12.14-4.3.31-6.48.53a.35.35,0,0,0-.33.35V5.84c-1.95.21-3.63.42-5.47.67V4.07a.36.36,0,0,0-.12-.27.34.34,0,0,0-.29-.08c-1.38.22-2.88.53-4.32.84l-2.43.49a.36.36,0,0,0-.3.35V8a.47.47,0,0,0,0,.17l1.06,2a.39.39,0,0,0,.28.19.41.41,0,0,0,.16,0A175.67,175.67,0,0,1,457.1,8.14c9.16,0,18.13,1.08,28.79,2.75h.05a.35.35,0,0,0,.24-.08.34.34,0,0,0,.12-.27v-.32c.28-.55.57-1.09.86-1.63l.2-.38a.33.33,0,0,0,0-.17V5.4A.35.35,0,0,0,487.12,5.05Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 426.63,
    y1: 6.21,
    x2: 490.3,
    y2: 6.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7b46d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ecd8b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ecd7af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7b46b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.7,10.8a182,182,0,0,1,29.23-2.46,144.22,144.22,0,0,1,27.29,2.46l-.5.83L484,13.28a196.66,196.66,0,0,0-26.26-2.19,177.83,177.83,0,0,0-25.47,2.19Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 429.39,
    y1: 10.67,
    x2: 486.63,
    y2: 10.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b69544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c6a765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b79542"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.54,27.13s14.67-1.72,30.44-2.06a147.1,147.1,0,0,1,28.92,2.17c0,.08-6.16-14.18-6.16-14.18s-10.42-1.32-22.9-1.64a141.83,141.83,0,0,0-24.44,1.75Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 428.21,
    y1: 19.31,
    x2: 488.46,
    y2: 19.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dab772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#dfc18a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dab772"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M459.12,25a228.43,228.43,0,0,0-37.85,3.27L406.82,46.64c22,14-.23,29.48-.23,50.52s44.05,29.27,51.39,43.3c7.34-14,51.38-22.27,51.38-43.3s-22.25-36.5-.22-50.52L494.68,28.26A190.51,190.51,0,0,0,459.12,25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.68,32.26,412.86,45.8c4.11,3.42,7.17,7.72,7.8,13.32.75,6.65-2.19,13.33-4.69,19.36s-5,12.13-5,18.68a10.47,10.47,0,0,0,.47,3.13c2.47,8,15,14.59,21.93,18.29,5.52,2.92,11.2,5.68,16.53,8.93a47,47,0,0,1,8.21,5.84,44.83,44.83,0,0,1,7.88-5.84c5.33-3.25,11-6,16.53-8.93C490,114.62,505,107,505,97.16c0-6.55-2.5-12.71-5-18.68s-5.39-12.7-4.64-19.35c.63-5.6,3.71-9.76,7.83-13.18L492.24,32.22a185.5,185.5,0,0,0-33.12-2.9,222.21,222.21,0,0,0-35.44,2.94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 408.72,
    y: 27.15,
    width: 99.49,
    height: 108.62
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 448.54,
    cy: 82.55,
    r: 52.81,
    gradientTransform: "translate(3.74) scale(1.01 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#009b5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008547"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.57,76.93h56.78c.46-18.14-9-36.75-28.39-36.75s-28.85,18.61-28.39,36.75"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 438.63,
    cy: 71.37,
    r: 38.11,
    gradientTransform: "translate(3.74) scale(1.01 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfefdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#d6ece0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#bde4e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#95d6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5dc4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5bc3ec"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.56,75.73c0,1.35.06,2.7.17,4,6.58.21,15-.18,15.26,1.07,0,.17.37.08.68,0s.58-.17.41,0c-3,3.34.72,9.09,4.53,12,11.83,9.17,7.5,14.33-2.08,16.4A26.46,26.46,0,0,0,458,111c10.93,0,18.68-5.85,23.3-14.19-7.08-2.81-19.07-4.28-21.85-10.57-.92-2.07,4.73-6,5.61-7.68,1.71-3.28-9.39-2.58-9.08-2.81l-26.19-.14c.09,0,0,.07-.19.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 426.93,
    y: 73.84,
    width: 56.85,
    height: 39.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 427.34,
    y1: 97.13,
    x2: 482.84,
    y2: 97.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fffbf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fdeedd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fbdbb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fad2a3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.56,75.38c-1.47,7.78,1.91,19.85,9,27.38,5.78,6.18,14,8.85,17.35,8.36.66-.1,1.24.21,1.45-.19,7.28-13.72-19.27-29.08-.41-35.18,3.47-1.13-19.31-.18-27.36-.18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 426.87,
    y: 73.92,
    width: 39.37,
    height: 39.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 428.62,
    y1: 93.07,
    x2: 465.98,
    y2: 93.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#09afb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#22b4b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#4abdc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ec1c5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M482.92,59.16c-6.71.07-5.89,8-10.52,8.54-1.1.11-4-1-5.93-1.25-2.6-.42-7.7,5.82-8.81,9.09h28.71a46.29,46.29,0,0,0-2.93-16.34,3.89,3.89,0,0,0-.49,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M482.92,59.16c-6.71.07-6.09,7.91-10.72,8.4-1.1.11-3.83-.81-5.73-1.11-2.6-.42-7.7,5.82-8.81,9.09h28.71a46.29,46.29,0,0,0-2.93-16.34,3.89,3.89,0,0,0-.49,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 472.19,
    y1: 58.08,
    x2: 472.19,
    y2: 75.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15a476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#109c6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#048654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007f4c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M459.66,91.36c4.66,4.86,13.2,5.51,19.48,8.75,4.77-6.57,7.18-15.38,7.22-24.21l-28.57-.34c-2.6,4.06-4,9.66,1.87,15.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 451.43,
    y: 74.62,
    width: 39.08,
    height: 28.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 453.14,
    y1: 89.6,
    x2: 486.98,
    y2: 89.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8b589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e3ae80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#d49967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce915d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.24,75h15.12a49.81,49.81,0,0,0-.48-6.23c-1.47-.19-3.7-.73-5.28-.92l-.29,0c-2.58,0-4.17,4.13-9.07,7.17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 480.27,
    y1: 67.81,
    x2: 480.27,
    y2: 75.59,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.79,53.68a.58.58,0,0,0,.59.58.58.58,0,1,0,0-1.16.58.58,0,0,0-.59.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "444.21 59.88 443.72 67.86 447.14 67.86 446.64 59.88 444.21 59.88"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 443.31,
    y: 58.41,
    width: 4.18,
    height: 1.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "448.32 62.75 448.32 63.88 447.16 63.88 447.16 62.75 446 62.75 446 63.88 444.85 63.88 444.85 62.75 443.7 62.75 443.7 63.88 442.54 63.88 442.54 62.75 441.39 62.75 441.39 74.76 449.47 74.76 449.47 63.88 449.47 62.75 448.32 62.75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.46,55.86v.19h3.88v-.19c0-.79-.87-1.44-1.94-1.44s-1.94.64-1.94,1.44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 441.34,
    y1: 68.73,
    x2: 449.75,
    y2: 68.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dad9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9fcff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 443.5,
    y1: 57.59,
    x2: 447.78,
    y2: 57.59,
    xlinkHref: "#linear-gradient-9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M530.51,30.12v-.48l3.11-3.85h.47a9.59,9.59,0,0,0,5.78,2.5c1.63,0,2.67-.5,2.67-1.35,0-1.18-1.48-1.28-3.68-1.89-3.38-.95-7.37-2.84-7.37-7.17,0-4,3.62-6.79,8.82-6.79,3.72,0,7.1,1.42,8.76,3.28v.47l-3.15,3.72h-.47a7.77,7.77,0,0,0-5-2.23c-1.29,0-2.13.47-2.13,1.25,0,1.08,1.52,1.59,3,2,3.78,1.08,8.08,2.36,8.08,7.33,0,4.56-4.26,6.93-9.16,6.93A13.31,13.31,0,0,1,530.51,30.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M560.79,16.9v3h7.64V25h-7.64v3h10.14v5.4H554.1v-22h16.73V16.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M574.17,22.48c0-6.52,5.27-11.39,12.24-11.39a12,12,0,0,1,9.26,4.22v.48l-4.06,3.44h-.47a6.6,6.6,0,0,0-4.77-2.13A5.26,5.26,0,0,0,581,22.48a5.25,5.25,0,0,0,5.37,5.37,6.56,6.56,0,0,0,4.77-2.13h.47l4.06,3.45v.47a12,12,0,0,1-9.37,4.23C579.48,33.87,574.17,29,574.17,22.48Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M619.12,33l-.31.5h-6.66L608,25.76h-1.59v7.7h-6.69v-22h10.07c5.78,0,8.89,2.84,8.89,7.34a6.38,6.38,0,0,1-4,6Zm-12.71-11.6h3.11a2.12,2.12,0,0,0,2.33-2.16,2.21,2.21,0,0,0-2.33-2.3h-3.11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M630.27,16.9v3h7.63V25h-7.63v3H640.4v5.4H623.57v-22H640.3V16.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M656.93,33.46h-6.69V16.9h-6.7V11.49h20.08V16.9h-6.69Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M687.07,33l-.3.5h-6.83l-1.28-3.31h-7.88l-1.35,3.31h-6.52l-.31-.5,10.11-21.47H677ZM677,25.76l-2.13-5.61-2.3,5.61Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M709.91,33l-.3.5H703l-4.16-7.7h-1.58v7.7h-6.7v-22h10.08c5.78,0,8.88,2.84,8.88,7.34a6.38,6.38,0,0,1-4,6Zm-12.7-11.6h3.11a2.12,2.12,0,0,0,2.33-2.16,2.21,2.21,0,0,0-2.33-2.3h-3.11Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M721.06,11.49v22h-6.69v-22Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M749,33l-.31.5h-6.82l-1.29-3.31h-7.87l-1.35,3.31h-6.53l-.3-.5,10.1-21.47h4.26Zm-10.11-7.2-2.13-5.61-2.3,5.61Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M781.48,22.44c0,6.63-4.42,11-11.62,11H759.62v-22h10.24C777.06,11.49,781.48,15.89,781.48,22.44Zm-6.82,0c0-3.58-2.13-5.58-5.07-5.58h-3.28V28.06h3.28C772.53,28.06,774.66,26.06,774.66,22.48Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M807.3,33l-.3.5h-6.83l-1.28-3.31H791l-1.35,3.31h-6.52l-.31-.5,10.11-21.47h4.26Zm-10.1-7.2-2.13-5.61-2.3,5.61Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M530.51,65.79v-.48l3.11-3.85h.47a9.59,9.59,0,0,0,5.78,2.5c1.63,0,2.67-.51,2.67-1.35,0-1.18-1.48-1.29-3.68-1.89-3.38-.95-7.37-2.84-7.37-7.17,0-4,3.62-6.79,8.82-6.79,3.72,0,7.1,1.42,8.76,3.28v.47l-3.15,3.72h-.47a7.77,7.77,0,0,0-5-2.23c-1.29,0-2.13.47-2.13,1.25,0,1.08,1.52,1.59,3,2,3.78,1.09,8.08,2.37,8.08,7.34,0,4.56-4.26,6.93-9.16,6.93A13.31,13.31,0,0,1,530.51,65.79Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M560.79,52.57v3h7.64v5.07h-7.64v3h10.14v5.4H554.1v-22h16.73v5.41Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M597.69,58.38a10.8,10.8,0,0,1-3.41,7.95,11.91,11.91,0,0,1-8.35,3.21c-6.69,0-11.76-4.87-11.76-11.39s5.14-11.39,11.76-11.39A12.21,12.21,0,0,1,595.26,51v.48L591.2,54.9h-.47a6.11,6.11,0,0,0-4.56-2.13,5.38,5.38,0,0,0,.17,10.75,5.08,5.08,0,0,0,3.14-1,4,4,0,0,0,1.39-1.76H586.2V56.05h10.92l.47.41A17.64,17.64,0,0,1,597.69,58.38Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M608.54,47.16v12c0,2.63,1.62,4.39,4,4.39s4-1.76,4-4.39v-12h6.59V58.79c0,6.46-4.26,10.75-10.61,10.75s-10.71-4.29-10.71-10.75V47.16Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M648,68.63l-.3.5H641l-4.16-7.7h-1.58v7.7h-6.7v-22h10.08c5.78,0,8.89,2.84,8.89,7.34a6.4,6.4,0,0,1-4,6ZM635.27,57h3.11a2.12,2.12,0,0,0,2.33-2.16,2.21,2.21,0,0,0-2.33-2.3h-3.11Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M674.6,68.63l-.3.5h-6.83l-1.28-3.31h-7.88L657,69.13h-6.52l-.31-.5,10.11-21.47h4.26Zm-10.1-7.2-2.13-5.61-2.3,5.61Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M698.73,47.16v22h-4.39l-9.6-11v11h-6.69v-22h4.39l9.6,11v-11Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M710.11,58.15a5.26,5.26,0,0,0,5.38,5.37,6.52,6.52,0,0,0,4.76-2.13h.48l4,3.45v.47a11.9,11.9,0,0,1-7.6,4.13l-.27.84c2.74,0,4.66,1.59,4.66,3.89,0,2.8-2.3,4.76-5.57,4.76a10,10,0,0,1-5.51-1.69v-.47l1.45-2.06h.47a6,6,0,0,0,2.91.81c1.22,0,2-.54,2-1.45,0-1.22-1.39-1.86-3.92-1.42l-.68-.44.88-2.77c-6-.78-10.34-5.34-10.34-11.29,0-6.53,5.27-11.39,12.23-11.39A12,12,0,0,1,724.78,51v.48l-4,3.44h-.48a6.56,6.56,0,0,0-4.76-2.13A5.27,5.27,0,0,0,710.11,58.15Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M750.74,68.63l-.31.5H743.6l-1.28-3.31h-7.88l-1.35,3.31h-6.52l-.3-.5,10.1-21.47h4.26Zm-10.11-7.2-2.13-5.61-2.3,5.61Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M780.67,54.63c0,4.53-3,7.47-8.88,7.47h-3.72v7h-6.69v-22h10.41C777.56,47.16,780.67,50.14,780.67,54.63Zm-6.82.21a2.16,2.16,0,0,0-2.3-2.27h-3.48V57h3.48A2.12,2.12,0,0,0,773.85,54.84Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M791.18,47.16v12c0,2.63,1.62,4.39,4,4.39s4-1.76,4-4.39v-12h6.6V58.79c0,6.46-4.26,10.75-10.62,10.75s-10.71-4.29-10.71-10.75V47.16Zm7.6-10.47,2.3,4v.47l-8.89,3.62h-.47l-1.49-2.57v-.47l8.08-5.07Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M830,63c0,3.82-3.21,6.18-8,6.18H811.22v-22h10.24c4.43,0,7.37,2.37,7.37,5.75A4.86,4.86,0,0,1,826,57.4,5.81,5.81,0,0,1,830,63Zm-9.73-11h-2.37v4h2.37a2,2,0,1,0,0-4Zm3.17,10.24c0-1.32-1-2.2-2.63-2.2h-2.91v4.4h2.91C822.41,64.37,823.45,63.49,823.45,62.17Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M849.51,69.13H834.43v-22h6.69V63.73h8.39Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M860.15,47.16v22h-6.69v-22Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M864.71,58.15c0-6.53,5.27-11.39,12.23-11.39A11.94,11.94,0,0,1,886.2,51v.48l-4.05,3.44h-.47a6.6,6.6,0,0,0-4.77-2.13,5.38,5.38,0,0,0,0,10.75,6.56,6.56,0,0,0,4.77-2.13h.47l4.05,3.45v.47a11.93,11.93,0,0,1-9.36,4.23C870,69.54,864.71,64.67,864.71,58.15Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M912.16,68.63l-.31.5H905l-1.29-3.31h-7.87l-1.35,3.31H888l-.3-.5,10.1-21.47h4.26Zm-10.11-7.2-2.13-5.61-2.3,5.61Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M538.59,88.24v3h7.64v5.07h-7.64v3h10.14v5.41H531.9v-22h16.73v5.41Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M583.7,93.78c0,6.63-4.42,11-11.62,11H561.84v-22h10.24C579.28,82.83,583.7,87.23,583.7,93.78Zm-6.82,0c0-3.59-2.13-5.58-5.07-5.58h-3.28V99.39h3.28C574.75,99.39,576.88,97.4,576.88,93.82Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M595,88.24v3h7.64v5.07H595v3h10.14v5.41H588.33v-22h16.73v5.41Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M616.78,88.24v3.55h7.3v5.07h-7.3v7.94h-6.69v-22h16.49v5.41Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M637.5,88.24v3h7.64v5.07H637.5v3h10.14v5.41H630.8v-22h16.73v5.41Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M651.18,101.46V101l3.11-3.85h.47a9.59,9.59,0,0,0,5.78,2.5c1.63,0,2.67-.51,2.67-1.35,0-1.18-1.48-1.29-3.68-1.89-3.38-1-7.37-2.84-7.37-7.17,0-4,3.62-6.79,8.82-6.79,3.72,0,7.1,1.42,8.76,3.28v.47l-3.15,3.72h-.47a7.8,7.8,0,0,0-5-2.23c-1.29,0-2.13.47-2.13,1.25,0,1.08,1.52,1.58,3,2,3.78,1.09,8.07,2.37,8.07,7.34,0,4.56-4.25,6.93-9.16,6.93A13.31,13.31,0,0,1,651.18,101.46Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M696.33,104.29l-.3.51H689.2l-1.28-3.31H680l-1.35,3.31h-6.52l-.31-.51L682,82.83h4.25ZM686.22,97.1l-2.12-5.62-2.3,5.62Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M705.59,101.46V101l3.1-3.85h.48a9.56,9.56,0,0,0,5.78,2.5c1.62,0,2.67-.51,2.67-1.35,0-1.18-1.49-1.29-3.69-1.89-3.38-1-7.36-2.84-7.36-7.17,0-4,3.61-6.79,8.82-6.79,3.71,0,7.09,1.42,8.75,3.28v.47L721,89.9h-.48a7.75,7.75,0,0,0-5-2.23c-1.28,0-2.13.47-2.13,1.25,0,1.08,1.52,1.58,3,2,3.79,1.09,8.08,2.37,8.08,7.34,0,4.56-4.26,6.93-9.16,6.93C711.16,105.21,707.58,103.65,705.59,101.46Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M727.82,93.82c0-6.53,5.27-11.39,12.27-11.39s12.27,4.86,12.27,11.39-5.27,11.39-12.27,11.39S727.82,100.34,727.82,93.82Zm17.71,0a5.44,5.44,0,1,0-5.44,5.37A5.3,5.3,0,0,0,745.53,93.82Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M755.73,93.82c0-6.53,5.28-11.39,12.24-11.39a12,12,0,0,1,9.26,4.22v.47l-4.06,3.45h-.47a6.6,6.6,0,0,0-4.77-2.13,5.38,5.38,0,0,0,0,10.75,6.56,6.56,0,0,0,4.77-2.13h.47l4.06,3.45V101a11.93,11.93,0,0,1-9.36,4.23C761,105.21,755.73,100.34,755.73,93.82Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M788,82.83v22h-6.69v-22Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M815.89,104.29l-.31.51h-6.83l-1.28-3.31H799.6l-1.36,3.31h-6.52l-.3-.51,10.1-21.46h4.26ZM805.78,97.1l-2.13-5.62-2.3,5.62Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M834.4,104.8H819.33v-22H826V99.39h8.38Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M547.1,125.87a6.77,6.77,0,0,1-7,6.8,7,7,0,1,1,0-13.92,7.16,7.16,0,0,1,5.66,2.58v.23l-2,1.69h-.23a4.39,4.39,0,0,0-3.4-1.59,4,4,0,0,0,.06,8.09,3.66,3.66,0,0,0,3.73-2.7h-3.77v-2.37h6.73l.22.2A8.54,8.54,0,0,1,547.1,125.87Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M549.1,125.71c0-4,3.16-7,7.35-7s7.35,3,7.35,7a7.36,7.36,0,0,1-14.7,0Zm11.42,0a4.07,4.07,0,1,0-4.07,4A4,4,0,0,0,560.52,125.71Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M579.68,119.2l-5.8,13.22h-2.62l-4.19-9.58c-.33-.77-.54-1-.81-1.14a.91.91,0,0,0-.66.06l-.2-.1-.56-2.19.08-.22a2.72,2.72,0,0,1,1.74-.5c1.63,0,2.49.83,3.15,2.39l2.81,6.88,3.74-9h3.2Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M585.4,121.64v2.79h5V127h-5v2.82H592v2.65h-9.77V119H592v2.64Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M607,131.94l-.1.23a3.21,3.21,0,0,1-1.82.5c-2,0-2.74-1.18-3.61-2.85-.43-.85-1.18-2.44-2-2.44h-1.06v5h-3.22V119H601c3.41,0,5.21,1.63,5.21,4.27a3.83,3.83,0,0,1-2.79,3.76,4.34,4.34,0,0,1,.79,1.16c.39.84.76,1.61,1.46,1.61a1.43,1.43,0,0,0,.54-.15l.2.1Zm-6-6.77a1.71,1.71,0,0,0,1.89-1.73,1.75,1.75,0,0,0-1.89-1.8h-2.65v3.53Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M621.75,119v13.42h-2.34l-6.42-8v8h-3.22V119h2.32l6.44,8v-8Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M624.79,125.71c0-4,3.15-7,7.35-7s7.35,3,7.35,7a7,7,0,0,1-7.35,7C627.94,132.67,624.79,129.69,624.79,125.71Zm11.41,0a4.07,4.07,0,1,0-4.06,4A4,4,0,0,0,636.2,125.71Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M660.84,125.69c0,4-2.75,6.73-7.06,6.73h-5.89V119h5.89C658.09,119,660.84,121.68,660.84,125.69Zm-3.31,0a3.71,3.71,0,0,0-3.88-4.07h-2.54v8.13h2.54A3.7,3.7,0,0,0,657.53,125.71Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M663.09,125.71c0-4,3.16-7,7.35-7s7.35,3,7.35,7a7.36,7.36,0,0,1-14.7,0Zm11.42,0a4.07,4.07,0,1,0-4.07,4A4,4,0,0,0,674.51,125.71Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M689.42,121.64v2.79h5V127h-5v2.82H696v2.65H686.2V119H696v2.64Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M698.24,130.35v-.29l1.48-1.77H700a5.08,5.08,0,0,0,3.57,1.65c1.18,0,2-.54,2-1.32,0-1-1.24-1.28-2.73-1.8-1.82-.62-4-1.5-4-4.09s2.25-4,5-4a6,6,0,0,1,4.77,2v.31L707,122.73h-.27a4,4,0,0,0-3-1.38c-1,0-1.75.44-1.75,1.2s1,1.22,2,1.61c2.19.76,4.75,1.59,4.75,4.44s-2.29,4.07-5.18,4.07A6.72,6.72,0,0,1,698.24,130.35Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M717.77,121.64v10.78h-3.22V121.64h-4.17V119H722v2.64Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M736.56,132l-.12.23a3.44,3.44,0,0,1-1.76.44,2.81,2.81,0,0,1-1.79-.56,5.63,5.63,0,0,1-1.41-2.05h-5.59l-.93,2.36h-3.39L727.31,119h2.79l4.29,9.62c.42.93.69,1.18,1.06,1.18a.9.9,0,0,0,.45-.15l.19.1Zm-9.78-4.17h3.82l-1.9-4.89Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M751.89,125.69c0,4-2.75,6.73-7.07,6.73h-5.88V119h5.88C749.14,119,751.89,121.68,751.89,125.69Zm-3.31,0a3.72,3.72,0,0,0-3.88-4.07h-2.54v8.13h2.54A3.71,3.71,0,0,0,748.58,125.71Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M754.14,125.71c0-4,3.16-7,7.35-7s7.35,3,7.35,7a7.36,7.36,0,0,1-14.7,0Zm11.42,0a4.07,4.07,0,1,0-4.07,4A4,4,0,0,0,765.56,125.71Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M790.19,125.69c0,4-2.75,6.73-7.06,6.73h-5.88V119h5.88C787.44,119,790.19,121.68,790.19,125.69Zm-3.3,0a3.72,3.72,0,0,0-3.88-4.07h-2.54v8.13H783A3.71,3.71,0,0,0,786.89,125.71Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M792.45,125.71c0-4,3.15-7,7.34-7s7.35,3,7.35,7a7.36,7.36,0,0,1-14.69,0Zm11.41,0a4.07,4.07,0,1,0-4.07,4A4,4,0,0,0,803.86,125.71Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M818.05,125.71a3.92,3.92,0,0,0,4,4,4.39,4.39,0,0,0,3.41-1.59h.23l2,1.66V130a7.16,7.16,0,0,1-5.66,2.63,7,7,0,1,1,0-13.92,7.16,7.16,0,0,1,5.62,2.62v.23l-2,1.65h-.23a4.39,4.39,0,0,0-3.41-1.59A3.93,3.93,0,0,0,818.05,125.71Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M833.68,121.64v2.79h5V127h-5v2.82h6.55v2.65h-9.77V119h9.77v2.64Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M857,132l-.12.23a3.41,3.41,0,0,1-1.75.44,2.82,2.82,0,0,1-1.8-.56,5.63,5.63,0,0,1-1.41-2.05h-5.59l-.93,2.36H842L847.7,119h2.79l4.3,9.62c.41.93.68,1.18,1.05,1.18a.9.9,0,0,0,.45-.15l.19.1Zm-9.78-4.17H851l-1.9-4.89Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M871.16,131.94l-.1.23a3.24,3.24,0,0,1-1.82.5c-2,0-2.74-1.18-3.61-2.85-.44-.85-1.18-2.44-2-2.44h-1.05v5h-3.22V119h5.84c3.41,0,5.21,1.63,5.21,4.27a3.83,3.83,0,0,1-2.79,3.76,4.11,4.11,0,0,1,.78,1.16c.4.84.77,1.61,1.47,1.61a1.43,1.43,0,0,0,.54-.15l.2.1Zm-6-6.77a1.71,1.71,0,0,0,1.9-1.73,1.75,1.75,0,0,0-1.9-1.8h-2.64v3.53Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M887.52,132l-.13.23a3.41,3.41,0,0,1-1.75.44,2.86,2.86,0,0,1-1.8-.56,5.62,5.62,0,0,1-1.4-2.05h-5.6l-.93,2.36h-3.38L878.27,119h2.78l4.3,9.62c.41.93.68,1.18,1,1.18a.86.86,0,0,0,.45-.15l.19.1Zm-9.25-14.2-.7-1.2v-.22l4.41-2.77h.23l1.2,1.94v.23l-4.92,2Zm-.54,10h3.82l-1.9-4.89Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M500.47,59.77c.62-5.56,4.56-9.38,9.11-12.28l.81-.51-15.2-19.3-.32-.06c-1.82-.35-3.63-.66-5.46-.95-5.54-.75-9.46-1.25-12.89-1.59l-2.83-.22h-.09l-.85-.06h-.22l-.23,0c-2.1-.13-4.19-.24-6.29-.31h0l-.75,0h0l-.63,0c-7.68-.16-14.48.1-19.31.39h0c-1.67.11-12.5,1.19-14.52,1.43l-.33,0c-2.45.34-7.51,1.12-9.35,1.41L405.9,47l.81.51c4.55,2.9,8.48,6.72,9.11,12.28s-2.33,11.8-4.39,16.76c-2.77,6.66-5.35,13.24-5.35,20.56a15.43,15.43,0,0,0,.71,4.63c1.51,4.87,5.26,8.79,9.22,11.9A101.1,101.1,0,0,0,431.16,123c5.4,2.86,11,5.56,16.2,8.74,3.47,2.11,8.09,5.24,10,8.89l.78,1.49.78-1.49c1.92-3.65,6.54-6.78,10-8.89,5.21-3.18,10.8-5.88,16.19-8.74a100.7,100.7,0,0,0,15.16-9.37c4-3.11,7.71-7,9.22-11.9a15.43,15.43,0,0,0,.71-4.63c0-7.32-2.58-13.9-5.35-20.56C502.8,71.57,499.85,65.22,500.47,59.77Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "476.74 5.68 479.81 6.15 479.83 4.29 476.74 5.68"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "449.34 3.21 449.31 5.01 451.09 4.89 449.34 3.21"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "465.16 4.87 466.94 4.98 466.91 3.19 465.16 4.87"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 426.63,
    width: 63.66,
    height: 12.43
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 429.39,
    y: 8.06,
    width: 57.24,
    height: 5.22
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 428.21,
    y: 10.89,
    width: 60.24,
    height: 16.82
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.14,24.79l-8.83.11a31,31,0,0,1,.56-5,6,6,0,0,1,2.19-3.17,3.74,3.74,0,0,1,3.2-.49,4.34,4.34,0,0,1,2.47,2.13A9.93,9.93,0,0,1,462.9,22a11.3,11.3,0,0,1,0,2.84Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M471.33,13.87c-1.41.09-2.68,1-2.58,2.12s.77,6.49.77,6.49l5.69.41-1-7.33S472.74,13.79,471.33,13.87Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 407.79,
    y: 27.15,
    width: 101.57,
    height: 110.81
  })))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.68,32.26,412.86,45.8c4.11,3.42,7.17,7.72,7.8,13.32.75,6.65-2.19,13.33-4.69,19.36s-5,12.13-5,18.68a10.47,10.47,0,0,0,.47,3.13c2.47,8,15,14.59,21.93,18.29,5.52,2.92,11.2,5.68,16.53,8.93a46.61,46.61,0,0,1,8.05,5.94,46.55,46.55,0,0,1,8-5.94c5.33-3.25,11-6,16.53-8.93C490,114.62,505,107,505,97.16c0-6.55-2.5-12.71-5-18.68s-5.45-12.71-4.7-19.36c.63-5.6,3.77-9.75,7.89-13.17L492.24,32.22a185.5,185.5,0,0,0-33.12-2.9,222.21,222.21,0,0,0-35.44,2.94"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "425.67 50.48 424.79 53.34 421.89 53.33 424.24 55.09 423.33 57.95 425.67 56.18 428.02 57.95 427.12 55.09 429.46 53.33 426.56 53.34 425.67 50.48"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "425.67 50.48 424.79 53.34 421.89 53.33 424.24 55.09 423.33 57.95 425.67 56.18 428.02 57.95 427.12 55.09 429.46 53.33 426.56 53.34 425.67 50.48"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "423.24 69.91 422.35 72.76 419.45 72.76 421.8 74.52 420.9 77.37 423.24 75.6 425.58 77.37 424.68 74.52 427.02 72.76 424.13 72.76 423.24 69.91"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "423.24 69.91 422.35 72.76 419.45 72.76 421.8 74.52 420.9 77.37 423.24 75.6 425.58 77.37 424.68 74.52 427.02 72.76 424.13 72.76 423.24 69.91"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "420.08 87.31 419.19 90.17 416.29 90.16 418.64 91.92 417.74 94.78 420.08 93.01 422.42 94.78 421.52 91.92 423.87 90.16 420.97 90.17 420.08 87.31"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "420.08 87.31 419.19 90.17 416.29 90.16 418.64 91.92 417.74 94.78 420.08 93.01 422.42 94.78 421.52 91.92 423.87 90.16 420.97 90.17 420.08 87.31"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "457.79 117.59 456.9 120.45 454 120.45 456.35 122.21 455.45 125.06 457.79 123.29 460.13 125.06 459.23 122.21 461.57 120.45 458.68 120.45 457.79 117.59"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "457.79 117.59 456.9 120.45 454 120.45 456.35 122.21 455.45 125.06 457.79 123.29 460.13 125.06 459.23 122.21 461.57 120.45 458.68 120.45 457.79 117.59"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "475.26 110.53 474.37 113.39 471.47 113.39 473.81 115.15 472.91 118 475.26 116.23 477.6 118 476.69 115.15 479.04 113.39 476.15 113.39 475.26 110.53"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "475.26 110.53 474.37 113.39 471.47 113.39 473.81 115.15 472.91 118 475.26 116.23 477.6 118 476.69 115.15 479.04 113.39 476.15 113.39 475.26 110.53"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "440.15 110.53 441.04 113.39 443.94 113.39 441.59 115.15 442.49 118 440.15 116.23 437.81 118 438.71 115.15 436.37 113.39 439.26 113.39 440.15 110.53"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "440.15 110.53 441.04 113.39 443.94 113.39 441.59 115.15 442.49 118 440.15 116.23 437.81 118 438.71 115.15 436.37 113.39 439.26 113.39 440.15 110.53"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "426.26 101.25 427.15 104.11 430.05 104.11 427.7 105.87 428.6 108.72 426.26 106.95 423.92 108.72 424.82 105.87 422.47 104.11 425.37 104.11 426.26 101.25"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "426.26 101.25 427.15 104.11 430.05 104.11 427.7 105.87 428.6 108.72 426.26 106.95 423.92 108.72 424.82 105.87 422.47 104.11 425.37 104.11 426.26 101.25"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 404.77,
    y: 39.08,
    width: 87.53,
    height: 64.59
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M429.56,75h16v.68h-16v-.16h0V75"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M429.56,75h16v.68h-16v-.16h0Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M429.7,71.94l15.91,3.12-.13.66-15.83-3.1c0-.22,0-.45.05-.68"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M429.7,71.94l15.91,3.12-.13.66-15.83-3.1C429.67,72.4,429.68,72.17,429.7,71.94Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M430.05,68.72l15.64,6.37-.27.62L430,69.41l.09-.69"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M430.05,68.72l15.64,6.37-.27.62L430,69.41Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M430.68,65.24l15.07,9.89-.38.57L430.53,66l.15-.71"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M430.68,65.24l15.07,9.89-.38.57L430.53,66Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M431.72,61.36,445.8,75.19l-.48.48L431.5,62.09l.22-.73"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M431.72,61.36,445.8,75.19l-.48.48L431.5,62.09Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M433.4,57l12.45,18.27-.57.37-12.2-17.9c.1-.25.21-.5.32-.74"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M433.4,57l12.45,18.27-.57.37-12.2-17.9C433.18,57.48,433.29,57.23,433.4,57Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M436.06,52.16l9.81,23.17-.63.26-9.63-22.73.45-.7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M436.06,52.16l9.81,23.17-.63.26-9.63-22.73Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M440.11,47.25l5.78,28.16-.68.13-5.69-27.7.59-.59"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M440.11,47.25l5.78,28.16-.68.13-5.69-27.7Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M445.76,43.12l.12,32.36h-.68l-.13-32c.23-.13.45-.26.69-.38"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M445.76,43.12l.12,32.36h-.68l-.13-32C445.3,43.37,445.52,43.24,445.76,43.12Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M452.74,40.66l-6.88,34.9-.67-.13L452,40.81l.72-.15"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M452.74,40.66l-6.88,34.9-.67-.13L452,40.81Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M460.48,40.29,445.83,75.63l-.63-.26,14.55-35.14c.25,0,.49,0,.73.06"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M460.48,40.29,445.83,75.63l-.63-.26,14.55-35.14C460,40.25,460.24,40.26,460.48,40.29Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M468.23,42.19l-22.44,33.5-.58-.37,22.37-33.4.65.27"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M468.23,42.19l-22.44,33.5-.58-.37,22.37-33.4Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M475,46.52,445.73,75.75l-.49-.48,29.27-29.2.51.45"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M475,46.52,445.73,75.75l-.49-.48,29.27-29.2Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M480.22,52.71,445.66,75.79l-.38-.56,34.57-23.09.37.57"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M480.22,52.71,445.66,75.79l-.38-.56,34.57-23.09Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M483.72,59.94,445.59,75.81l-.27-.62L483.48,59.3l.24.64"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M483.72,59.94,445.59,75.81l-.27-.62L483.48,59.3Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M485.71,67.64l-40.2,8.19-.14-.67L485.59,67l.12.66"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M485.71,67.64l-40.2,8.19-.14-.67L485.59,67Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M486.37,75.51l-40.94.31v-.67l40.93-.31c0,.22,0,.45,0,.67"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M486.37,75.51l-40.94.31v-.67l40.93-.31C486.36,75.06,486.37,75.29,486.37,75.51Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M445.54,65.19A10.4,10.4,0,0,1,456,75.5h-21a10.41,10.41,0,0,1,10.49-10.31"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M445.54,66.08a9.42,9.42,0,0,1,9.62,9.19H435.91a9.42,9.42,0,0,1,9.63-9.19"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 427.34,
    y: 74.03,
    width: 55.51,
    height: 46.21
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 428.62,
    y: 74.96,
    width: 37.36,
    height: 36.22
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457.33,111.28h0a25.87,25.87,0,0,1-21.15-11.49c-4.51-6.44-7-15-7-24.22a.37.37,0,0,1,.37-.36h27.33a.35.35,0,0,1,.11.69c-3.49,1.07-5.58,2.53-6.38,4.45-1.34,3.18,1,7.47,3.43,12,3.19,5.88,6.79,12.55,3.61,18.73A.36.36,0,0,1,457.33,111.28ZM429.92,75.92c.1,16.33,8.61,34,27.19,34.65,2.83-5.8-.63-12.22-3.7-17.88-2.53-4.69-4.93-9.12-3.46-12.61.72-1.73,2.33-3.1,4.89-4.16H429.92Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 456.95,
    y: 58.08,
    width: 30.47,
    height: 17.36
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M441.29,95.8c-3.77-7.67-1.84-12.43,3.42-15.35-2.39,4.22,1.09,7.78,6.13,11.72a25.35,25.35,0,0,0-9.42,3.56Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 453.14,
    y: 74.96,
    width: 33.84,
    height: 29.28
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 470.82,
    y: 67.81,
    width: 18.89,
    height: 7.78
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 443.5,
    y: 56.42,
    width: 3.81,
    height: 1.99
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 443.5,
    y: 56.42,
    width: 3.81,
    height: 1.99
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M459.21,52.1a20,20,0,0,1,7.27.87c1.8.65,2.49.62,4.15,2.18l-2.52,1.58c-2.54-2.81-5.71-3.3-9-4.24-1.37-.4-1.32-.36.07-.39"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M469.51,55.13c2,.14,4.37-1.39,5.35-1.58.33-.06.94.53.65.81a16.41,16.41,0,0,1-1.61.75,12.58,12.58,0,0,1,1.79-.78c.5.08.8.88.59,1.05a21.29,21.29,0,0,0-2,.64,9.65,9.65,0,0,1,2-.64c.26,0,.56.81.18,1-1.11.71-2.57.74-3.75,1.26.45,1.76,1.61,3.77,1.55,5.59-.09,2.83-1.66,5.49-2.14,8.15-.18,1-.05,1.3-.27.1-.62-3.47-.86-9.62-2.48-11.89a8.9,8.9,0,0,0-2-1.07,8,8,0,0,0-1.9-.24c-.44.12-1.51.35-2,.48.15-.83.8-3.16,2.37-3Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M470.26,85.4l-.05.91,1.21.89,0-1-1.1-.81Zm-.55,16.19,0,.91.11.07H471Zm.07-1.81,0,.93,2.14,1.58,0-1Zm.06-1.8,0,.94,2,1.49,0-1Zm.06-1.81,0,.93,1.93,1.45v-1Zm.06-1.81,0,1,1.81,1.32,0-1Zm.06-1.81,0,1,1.69,1.26,0-1Zm.06-1.8-.05,1,1.56,1.14,0-1Zm.07-1.81-.06,1L471.53,91l0-1Zm.06-1.81-.07,1,1.35,1-.05-1Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M469.61,101.7l0,.9.11.08h1.24Zm.07-1.81,0,.9,2.14,1.59,0-.94Zm.06-1.81,0,.9,2,1.51,0-.95Z"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "449.75 75.04 441.34 75.04 441.34 62.42 449.73 62.42 449.75 75.04"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M447.15,62.22l-3.58,0,.12-1.83-.19-.23,0-5.17a6,6,0,0,0,.8-.84c.4-.49.67-1.13,1.17-1.13.75,0,.53.59.86,1.07a13,13,0,0,0,1.25,1.4l.08,2.94.08,1.79-.75.16Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 443.72,
    y: 56.52,
    width: 3.42,
    height: 1.59
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M444.47,13.85c1.41.08,2.68,1,2.58,2.11s-.78,6.49-.78,6.49l-5.68.41,1-7.33S443.06,13.76,444.47,13.85Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M443,16.21c-.18,1.95-.43,3.29-.61,5.24,1-.09,1.71-.09,2.48-.16.25-1.92.44-3.35.68-5.27C445.08,14.9,443.79,15.05,443,16.21Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M473.39,21.45c-.18-1.95-.44-3.29-.62-5.24-.77-1.16-2-1.31-2.55-.19.24,1.92.44,3.35.68,5.27C471.68,21.36,472.38,21.36,473.39,21.45Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M461.68,24.62l-.05-.71h0c-.21-2.5-.39-6.48-3.52-6.48s-3.22,4.12-3.42,6.57h0l0,.6Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M458.13,16.45c4.07,0,4.17,4.87,4.49,7.9l0,.16,0,.09h.78l0-.23h0c-.07-.82-.15-1.71-.28-2.6l1.87,0,.25,2.6h0l0,.19H466l0-.17h0l-.25-2.6,3.37.13.13,1,1.5.15c.83.08,1.67.09,2.51.16l2.24.18-.11-1.14c1.45.1,2.89.23,4.33.37l.7,2.74.09.42.73,0-.12-.69-.61-2.41,5.26.63L486.89,26h0l.11.24h0l.08.21.9.12v-.18h0l-5.74-13.06,2,.32,2.13-1.8,1.53-3.24a17.75,17.75,0,0,0,.1-3.77c-1.18-.23-7.72-1.55-8.24-1.48l-4.65,2.08V2.8l-8.23-.66v0l-2.83,2.65-1.81,0V2L454,2V4.79l-1.79.06-2.86-2.68-8.23.66V5.49l-4.65-2.06c-.54-.07-7,1.22-8.23,1.45a17.68,17.68,0,0,0,.1,3.76c1.91,3.91.52,2.48,3.92,5l1.58-.24-5.61,13.16c0,.1,0,.07,0,.07v.18l.84-.12.11-.18h0l1.3-3h.05l5.25-.62L435,25.69l0,.1-.05.55h.68L436,25l.57-2.22c1.29-.13,2.59-.24,3.89-.35l-.09,1,2.23-.18c.84-.07,1.68-.08,2.52-.16l1.5-.15.12-1q1.91-.09,3.81-.15l-.2,2-.08,1H451l0-.33v-.08h0l.26-2.64,1.92-.05.12-.74-6.51.27c.11-.88.23-1.76.34-2.64l7-.31A18.62,18.62,0,0,0,452.93,24h0l-.07.71h.76l0-.37h0C454,21.4,454.16,16.45,458.13,16.45Zm10.93-2q-5.25-.3-10.5-.32V11.52c4,0,8,.19,12,.51l.24,1.4-.29.07A2.88,2.88,0,0,0,469.06,14.4Zm-.71,1.85c.07.52.13,1.05.2,1.57l-3.18-.13-.23-2.75c1.15,0,2.29.09,3.44.16l-.09.18-.2.47Zm5,6.12c-.83-.06-1.67-.08-2.5-.16l-.75-.07-.1-.74c-.22-1.76-.45-3.51-.67-5.26l0-.25.1-.24a2.15,2.15,0,0,1,1.4-1.26,2.7,2.7,0,0,1,2.8,1.31l.13.2,0,.23c.16,1.75.45,3.48.61,5.23l.11,1.1Zm1.34-6.32,0-.47,0,0c1.13.11,2.25.22,3.36.35l.69,2.7c-1.24-.13-2.48-.25-3.72-.35C474.81,17.51,474.72,16.78,474.65,16.05Zm10.74,6.58h-.13c-3.31-.44-6.63-.77-10-1l0-.31c-.07-.77-.16-1.53-.26-2.3,3.09.26,6.18.6,9.25,1Zm-1.49-3.4-.13,0-4.35-.54L478.74,16l4,.52Zm-1.55-3.52-.13,0-8.14-.87a3.84,3.84,0,0,0-2.52-1.41l-.22-1.32c3.32.29,6.62.67,9.92,1.14ZM479.81,4.37l0,1.73c-1-.13-2-.26-2.92-.44Zm-12.92-1.1V4.92l-1.67-.07Zm-17.52,0,1.7,1.61-1.7.07ZM436.49,4.43l3,1.33-3,.38Zm-6.28,5.84c-1.34-2.55-1-1.62-1-4.66,2.14-.42,4.29-.8,6.43-1.14V7.16c2.15-.3,4.29-.56,6.44-.79V3.63c2.15-.21,4.29-.38,6.44-.52V5.88c2.15-.1,4.29-.18,6.44-.22V2.88c2.15,0,4.29,0,6.44,0V5.64c2.14,0,4.29.1,6.44.2V3.08q3.21.21,6.44.52V6.32q3.21.34,6.44.8V4.44q3.21.52,6.44,1.17c0,3.12.29,2-1.1,4.71A181.92,181.92,0,0,0,457.28,8a176.3,176.3,0,0,0-27,2.26Zm2.3,2.43-2.14-1.57a169,169,0,0,1,55.47.06L484,12.75l-9.41-1.24A159.62,159.62,0,0,0,432.51,12.7Zm2.3.55c3.37-.48,6.73-.87,10.1-1.15l-.21,1.3a3.69,3.69,0,0,0-3,1.5l-7.9.83Zm-1.39,3.27h0l4-.51-.7,2.76-4.56.55Zm7.11,4.76,0,.42q-4.86.38-9.71,1l1.11-2.61h0c2.94-.4,5.89-.72,8.85-1C440.69,19.83,440.6,20.55,440.53,21.28Zm.61-5.23c-.07.77-.16,1.54-.26,2.31-1.1.09-2.2.2-3.3.31l.71-2.76,2.89-.29Zm5.37.09c-.22,1.75-.46,3.5-.68,5.26l-.09.74-.76.07c-.82.08-1.66.1-2.49.16l-1.12.09.1-1.1c.16-1.75.45-3.48.61-5.23l0-.23.13-.2a2.71,2.71,0,0,1,2.8-1.31,2.19,2.19,0,0,1,1.41,1.26l.1.24Zm.27-1.7a2.93,2.93,0,0,0-1.35-.9l.25-1.51c4-.32,8.08-.5,12.14-.51v2.56C454.13,14.11,450.46,14.22,446.78,14.44Zm4.08,3.3c-1.21,0-2.42.1-3.63.17.08-.56.15-1.11.21-1.66l.07-.5-.21-.47-.06-.13c1.29-.07,2.57-.14,3.85-.19Zm.75,0,.24-2.78c4.17-.14,8.36-.16,12.54,0l.23,2.76-2.83-.06a4.88,4.88,0,0,1,.42.74l6.44.26c.12.89.23,1.77.35,2.65L463,21l.05.32c-.46-2.87-1.53-5.63-4.91-5.63a4,4,0,0,0-3.62,1.92Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 444.64,
    y: 66.92,
    width: 2,
    height: 1.93
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M449.38,96.91a.65.65,0,0,0,0-1.07h-1.63v-1a.38.38,0,0,0-.38-.37h-.9a.38.38,0,0,0-.37.37v1h-3.7a25.73,25.73,0,0,1,8.32-3l1.56-.32-1.25-1c-2.22-1.73-6.21-4.8-6.52-7.8a4.66,4.66,0,0,1,.66-2.77l1.3-2.29L444.18,80c-6.56,3.65-6.62,9.67-3.61,15.84h-.95v-.56h-1.27v.56h-1.42c-.37.29-.37.64,0,1.07A39.38,39.38,0,0,0,449.38,96.91Zm-4.84-16.27c-2.38,4.21,1,7.58,6,11.51a24.59,24.59,0,0,0-9.26,3.53C437.75,88.49,439.31,83.55,444.54,80.64Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M465.92,56.66a.36.36,0,0,0-.37.33.37.37,0,0,0,.32.39.35.35,0,0,0,.37-.33A.37.37,0,0,0,465.92,56.66Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M500.47,59.77c.62-5.56,4.56-9.38,9.11-12.28l.81-.51-15.2-19.3-.32-.06c-1.82-.35-3.63-.66-5.46-.95-5.54-.75-9.46-1.25-12.89-1.59l-2.83-.22h-.09l-.85-.06h-.22l-.23,0c-2.1-.13-4.19-.24-6.29-.31h0l-.75,0h0l-.63,0c-7.68-.16-14.48.1-19.31.39h0c-1.67.11-12.5,1.19-14.52,1.43l-.33,0c-2.45.34-7.51,1.12-9.35,1.41L405.9,47l.81.51c4.55,2.9,8.48,6.72,9.11,12.28s-2.33,11.8-4.39,16.76c-2.77,6.66-5.35,13.24-5.35,20.56a15.43,15.43,0,0,0,.71,4.63c1.51,4.87,5.26,8.79,9.22,11.9A101.1,101.1,0,0,0,431.16,123c5.4,2.86,11,5.56,16.2,8.74,3.47,2.11,8.09,5.24,10,8.89l.78,1.49.78-1.49c1.92-3.65,6.54-6.78,10-8.89,5.21-3.18,10.8-5.88,16.19-8.74a100.7,100.7,0,0,0,15.16-9.37c4-3.11,7.71-7,9.22-11.9a15.43,15.43,0,0,0,.71-4.63c0-7.32-2.58-13.9-5.35-20.56C502.8,71.57,499.85,65.22,500.47,59.77Zm-42.33,80.46c-7.31-14-51.18-22.18-51.18-43.14s22.16-36.35.22-50.33l14.4-18.3q38.75-6.51,73.12,0l14.4,18.3c-21.93,14,.23,29.38.23,50.33S465.46,126.26,458.14,140.23Z"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "436.46 6.18 439.66 5.77 436.46 4.38 436.46 6.18"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M500.78,78.14c-2.42-5.84-5.34-12.42-4.62-18.87.59-5.25,3.45-9.35,7.47-12.69l.65-.54L492.74,31.59l-.33-.06c-22.72-4.1-45.85-3.63-68.59,0l-.34.06L412,46l.64.54c4,3.34,6.88,7.44,7.47,12.69.73,6.45-2.19,13-4.61,18.87-2.52,6.07-5,12.28-5,18.93a11.28,11.28,0,0,0,.51,3.37c2.56,8.24,15,14.86,22.27,18.73,5.49,2.91,11.11,5.64,16.42,8.87a46.1,46.1,0,0,1,7.86,5.8l.61.59.62-.59a45.32,45.32,0,0,1,7.86-5.8c5.31-3.23,10.93-6,16.42-8.87,7.91-4.2,22.78-11.89,22.78-22.1C505.8,90.42,503.3,84.21,500.78,78.14ZM482.6,118.41c-5.49,2.91-11.16,5.67-16.46,8.9a46.35,46.35,0,0,0-8,5.91,46.67,46.67,0,0,0-8-5.91c-5.31-3.23-11-6-16.47-8.9-6.94-3.68-19.38-10.28-21.84-18.22a10.35,10.35,0,0,1-.47-3.12c0-6.52,2.48-12.66,4.95-18.6S421.7,65.8,421,59.18c-.63-5.58-3.68-9.86-7.78-13.26l6.15-7.7,15.09,14.89c-9.57,16.12-7.29,42,7.13,53.24a26.27,26.27,0,0,0,16.57,5.53c10.46,0,18.14-5.14,23-12.68l12.79,12.62A115.27,115.27,0,0,1,482.6,118.41Zm-21.9-78a2.14,2.14,0,0,1,.32,0,25.82,25.82,0,0,1,6,1.33h0l.57.21.1,0h0l.64.27h0l.14.07.18.07.15.07a24.77,24.77,0,0,1,5.22,3.2s0,0,.05,0c.24.2.62.51,1,.88h0l.32.29.09.09a29.19,29.19,0,0,1,4.3,5.07h0l0,.05.07.09h0l.37.56h0l-.15-.24.15.24h0l0,0,0,.07h0a34.92,34.92,0,0,1,2.84,5.59H483a6.89,6.89,0,0,0-6.16,3.65c0,.07-.37.65-.6,1a19.74,19.74,0,0,1-1.62,2.55,10.36,10.36,0,0,0,.28-1.39c0-.21.06-.42.07-.64h0c0-.27,0-.76,0-.76,0-1.68-.88-3.2-1.38-4.79A12,12,0,0,0,476.81,57,1.4,1.4,0,0,0,477,55.1a3.27,3.27,0,0,0-.12-.5,2.59,2.59,0,0,0-.24-.39,1.54,1.54,0,0,0-.5-.45,1.44,1.44,0,0,0-1.49-.88,6.84,6.84,0,0,0-1.55.61,19.71,19.71,0,0,1-1.83.78l-.57.17a15.72,15.72,0,0,0-2.16-1.31h0c-.24-.12-.5-.24-.92-.42l-.69-.26a17.46,17.46,0,0,0-4.77-1h0c-.54,0-1.06-.05-1.81-.07h-.87c-.58,0-1.68-.14-1.79.69s1,1,1.52,1.13l.07,0,1.59.44h0a19.41,19.41,0,0,1,4.48,1.62,2.45,2.45,0,0,0-1.79,1.55l-.16.37a8.94,8.94,0,0,0-.4,1.42h0l-.16.92,1.13-.31c.47-.13,1-.19,1.52-.31a5.93,5.93,0,0,1,1.53.3h0c.38.14.76.29,1.13.47l.09,0a1.82,1.82,0,0,1,.76.49h0a.16.16,0,0,0,0,.07v0a14.47,14.47,0,0,1,1.13,4.38h0v.11h0c0,.17.05.43.09.7h0c0,.27.06.53.09.76l0,.37-1.15-.31-.3-.08h0l-.06,0c-.38-.1-1.13-.29-1.54-.38l-.76-.15A4.82,4.82,0,0,0,463.38,67c-.28.21-.56.44-.83.68a22.72,22.72,0,0,0-1.88,1.93h0l-.29.35c-.48.58-.88,1.12-1.33,1.74-.19.27-.38.55-.56.83h0c-.23.37-.42.71-.57,1-.24.45-.46.9-.64,1.33h-6.89V62.07h-2.68l-.09-1.5h.8V57.75h-.7v-.9h.55v-.92a2.11,2.11,0,0,0-1.4-1.9l0-.27a1.3,1.3,0,0,0-.91-1.24,1.57,1.57,0,0,0-.37-.05h-.32a1.31,1.31,0,0,0-1.05,1.28l0,.29a2.09,2.09,0,0,0-1.36,1.88v.92h.55v.9h-.69v2.82h.85l-.09,1.5h-2.68V74.83h-11c0-.18,0-.35,0-.52a3.35,3.35,0,0,1,0-.66c0-.69.06-.87.13-1.71h0l0-.39,0-.31a29.61,29.61,0,0,1,.4-3.29c0-.22.07-.44.11-.64h0c.18-1,.35-1.82.52-2.56.09-.39.17-.7.25-1l0-.1c.1-.38.21-.76.36-1.3s.34-1.14.54-1.71c.14-.4.29-.81.44-1.21l0-.11a18.23,18.23,0,0,1,1-2.48l.09-.18a35.07,35.07,0,0,1,2-3.63v0a20.75,20.75,0,0,1,1.86-2.66c.11-.15.22-.29.34-.43l.09-.12a18.71,18.71,0,0,1,2.36-2.56l.06-.06a26.36,26.36,0,0,1,3.78-3l.08-.06a12.84,12.84,0,0,1,1.57-.91l.41-.21a24.32,24.32,0,0,1,4.54-1.77l.09,0a17.25,17.25,0,0,1,2-.46h0a27.47,27.47,0,0,1,5.15-.47h.32l1.1,0,.37,0h0ZM429.81,75.56h27a20.42,20.42,0,0,0-2.45.93l-.21.1-.64.33c-.24.13-.46.27-.67.41h0a5.75,5.75,0,0,0-3,5,9.24,9.24,0,0,0,.42,2.72h0l.09.3v0c.11.33.23.68.36,1a34.15,34.15,0,0,0,1.51,3.32c.4.78.81,1.55,1.22,2.33,1.81,3.38,3.81,6.92,4.62,10.7a12.14,12.14,0,0,1-.28,6.73v0a7.22,7.22,0,0,1-.29.72c-.07.18-.16.36-.25.54h0c-.7,0-1.4-.07-2.1-.14a24.89,24.89,0,0,1-10.65-3.59c-10.43-6.5-15-19.81-14.68-31.46v0ZM443.9,63.92V62.79h1.15v1.13h1.15V62.79h1.15v1.13h1.15V62.79h1.15v2.47h-8.06V62.79h1.16v1.13Zm1.7-9.43h0c1.06,0,1.93.65,1.93,1.44v.19h-3.87v-.19C443.66,55.14,444.53,54.49,445.6,54.49Zm-.61-.73a.59.59,0,0,1,1.17,0v.06a2.71,2.71,0,0,0-.56,0,3.15,3.15,0,0,0-.61.06Zm2,3.09v.9H446v-.9Zm-1.74,0v.9h-1v-.9Zm2.47,1.63v1.36h-4.16V58.48ZM447,62.07h-2.69l.09-1.5h2.5Zm2.68,4v3.48h-8.06V66Zm0,4.24v4.49h-3V72.31a1.1,1.1,0,1,0-2.17,0v2.45h-2.91V70.27Zm8.45,40.54c2.45-5.16.58-10.36-1.92-15.3-1.43-2.84-3.08-5.59-4.23-8.19-.75-1.7-1.56-3.89-1.25-5.81a5,5,0,0,1,2.23-3.39,16,16,0,0,1,3.08-1.5h0l.11-.05.44-.15c-2.91,5.46-1.82,10.68,2.69,15.38,2.56,2.68,6.22,4.11,10,5.36l-.21,6h3.42v-.6c0-1.47-.07-3-.11-4.42a43.26,43.26,0,0,1,6.39,2.47,25.08,25.08,0,0,1-20.64,10.21h0ZM472.26,87l1.12,1.14.43-.41-1.25-1.28a7.14,7.14,0,0,1,2.35,2l0,.17,0,.2-.26,2.59L473.38,90l-.14-.1-.06-.21A13.68,13.68,0,0,0,472.26,87Zm.41,3.16-.54,1.24c0-1.15-.07-2.29-.1-3.44a20,20,0,0,1,.62,2.09l0,0Zm.68-3.94,1.18.39.19-.56-1.43-.47a7.6,7.6,0,0,1,1.95.34l.13.06.07.13,1.42,2.48-1.28-.26h0l0,0A7.88,7.88,0,0,0,473.35,86.2Zm2.27-.85-.08,0-.08,0A7.88,7.88,0,0,0,473.2,85l1.62-.27-.1-.58-1.9.32a11.21,11.21,0,0,1,1.68-.82l.16-.08.22,0,2.76.44Zm-.4-5.36-.7.28.78-.57Zm-.19.71-.59,2.21,0,.09-.08,0a11.09,11.09,0,0,0-2.55,1.36l1.88-2.12-.46-.39-1.64,1.87a8.65,8.65,0,0,1,1-2l.09-.12.13,0Zm-5.29,20,0-.89,2.07,1.53,0,.94Zm1.29,1.88h-1.24l-.11-.08,0-.89Zm.41-14.47,0,.94-1.29-1,0-.9Zm-1.2-1.82,0-.82,0,0,1.09.81,0,.94ZM471.49,90l0,.94-1.41-1,0-.9Zm.06,1.89,0,1-1.53-1.14,0-.9Zm.07,1.89,0,1L470,93.49l0-.9Zm.06,1.9,0,.94-1.78-1.32,0-.9Zm.06,1.89,0,1-1.9-1.42,0-.9Zm.06,1.89,0,.94-2-1.5,0-.9Zm.22-18a9.22,9.22,0,0,0-.9,1.77V81.13h-.6v2.61a9.39,9.39,0,0,0-1.13-2.32l0-.16,1.31-2.52L472,81.35v.08Zm-2.15,2.19L468.24,82l-.42.41L470,84.63h0a10,10,0,0,0-2.81-1.58l-.1-.14-.61-2.28,2.23.9.14.07.08.11A8.38,8.38,0,0,1,469.87,83.69Zm-3.64-3.77-.07-.27.74.54Zm.36,3.65.17,0,.15,0,1.68.81-1.67-.28-.11.58,1.63.27a8.42,8.42,0,0,0-2.24.39h-.08l-.08,0L464,84Zm-.37,2.52.09-.12.11-.06a7.91,7.91,0,0,1,2-.35l-1.5.5.19.56,1.22-.41a8.66,8.66,0,0,0-2.14,2l-.06.06-.05.07-1.28.26Zm.54,2.34a7.62,7.62,0,0,1,2.12-1.86l-1.1,1.09.42.42,1.38-1.37a11.27,11.27,0,0,0-1.15,3.07h0l-.05.12-.1.11L467,91.36l-.26-2.59v-.19Zm2.27,1.4a12.86,12.86,0,0,1,.55-1.75l-.11,3.17L469,90.14V90Zm3.3,7.54-.15-4.61.53-1.21,0,1.69h.59l0-1.61.59,1.52.55-.21-.61-1.61,1.15,1.2.43-.41-.19-.2.17-1.74.45,1.69.58-.15L476,90.08l1,1.39.49-.34-1.08-1.54,1.5,1,.32-.5-1.41-.9.48.1.17.3.35-.19.64.13.12-.58-.17,0,.36-.34-1.45-1.49,1.77,1,.3-.51-1.94-1.12,2.17.48.13-.57-1.79-.4,1.83-.06,0-.59-2,.07,2-.64-.18-.56-1.95.63,1-.66h0l.74-.49-.34-.49-.54.36-1.46-.22,1.9-.21-.07-.59-2.15.24,1.94-.83-.24-.54-1.95.83,1.61-1.37-.39-.44L476,81.75l1.14-1.81-.51-.31,0,0-.08-.19-.57.23.08-.31-.21-.05.39-.29-.35-.47L474,80l1.37-1.78-.47-.35-1.51,1.93.83-2.26-.56-.2-.7,1.9.18-2-.59-.06-.2,2.23-.44-2.21-.59.11.44,2.2L471,78.1l.26-.5-.53-.27-.07.13,0,0-.53.27.22.41-.66,1.26.44-2.19-.59-.11-.44,2.21L468.9,77l-.59,0,.18,2-.7-1.91-.56.2.83,2.27-1.51-1.94-.47.36,1.38,1.77-1.87-1.36-.35.48.49.35-.25.07.06.24-.61-.25-.12.28-.43.27,1.14,1.81-1.6-1.36-.39.44,1.61,1.37-1.95-.83-.24.54,1.94.83-2.15-.24-.06.59,1.89.21-1.31.2-.5-.34-.34.49.52.35,0,.14.15,0,1,.68-1.95-.63-.18.56,2,.64-2-.07,0,.59,1.84.06-1.79.4.13.57,2.17-.48-1.94,1.12.3.51,1.77-1-1.45,1.49.36.34-.17,0,.12.58.64-.13.35.19.17-.3.48-.1-1.41.9.32.5,1.5-1-1.09,1.54.5.34,1-1.39-.44,1.65.58.15.45-1.69.17,1.74-.2.2.44.41,1.15-1.2L467.21,93l.57.21.58-1.52,0,1.61H469l0-1.69.47,1.08-.13,3.77c-3.63-1.21-7.08-2.59-9.49-5.11-5.52-5.76-4.59-11-2.3-15h0v0h0v0h0v0h0l.1-.17h0l.1-.17h0l.09-.15h0l1.34,0,27.11.31h0c0,8.81-2.44,17.57-7.2,24.13A43.31,43.31,0,0,0,472.33,97.37ZM477,87.63l1.17,1.21-.55-.11Zm-1.56-6.21.27-1,.49-.19Zm-9.43,0-.81-1.27.52.21Zm-1.37,6.21-.63,1.1-.54.11ZM486.4,75H471.33c5.07-3.14,6.58-7.44,9.33-7.12,1.57.18,3.79.73,5.25.92h0a50.15,50.15,0,0,1,.49,6.14Zm-.95-7c-.72-.12-1.45-.26-2.17-.4s-1.69-.33-2.53-.43a3.16,3.16,0,0,0-1,0c-1.53.29-2.83,1.79-3.85,2.87a24.33,24.33,0,0,1-5,4.32l-1.17.63-11.67-.13c1.51-3.38,6.08-8.73,8.5-8.35,1.17.19,2.74.67,4,1,.14,1.37.27,2.75.51,4.09.08.49.05,1.45.88,1.42s.72-1,.81-1.48a31,31,0,0,1,1.33-4.37c3-1.94,3.08-7.84,8.82-7.9a3,3,0,0,1,.52,0h0A43.73,43.73,0,0,1,485.8,68ZM466,56l3.44-.71c2,.14,4.42-1.53,5.39-1.71a.78.78,0,0,1,.66.41l-2,1,.25.53,2.2-1a1,1,0,0,1,.37.8l-2.35.57.13.57,2.49-.58a.55.55,0,0,1-.14.61c-1.11.71-2.57.74-3.74,1.25.45,1.76,1.6,3.76,1.54,5.57,0,.19,0,.38,0,.57l-1.28-2.68-.54.26L474,64.81a16.33,16.33,0,0,1-.5,1.88l-1.31-4.45-.57.16,1.56,5.25a25.67,25.67,0,0,0-1.12,3.71c-.18,1,0,1.27-.22.07-.62-3.45-.65-9.55-2.27-11.82a10.34,10.34,0,0,0-2.22-1,6.56,6.56,0,0,0-1.88-.36c-.44.12-1.28.29-1.72.41C463.91,57.79,464.44,55.83,466,56Zm-6.53-3.5c-1.36-.4-1.31-.36.08-.39a19.89,19.89,0,0,1,7.16,1,13.83,13.83,0,0,1,2.94,1.45h-.26l-2.81.58C464.43,53.69,462,53.24,459.47,52.52Zm35.46,58.6-13.13-13c9.7-16.2,7.25-42.36-7.42-53.58a26.16,26.16,0,0,0-16.26-5.35c-10.47,0-18.16,5.21-23.06,12.83l-15-14.78L424,32.42c22.67-3.65,45.66-4.13,68.29,0l10.82,13.54c-4.1,3.4-7.15,7.68-7.78,13.26-.75,6.62,2.18,13.29,4.68,19.29s4.95,12.08,4.95,18.6C504.92,102.5,500.31,107.28,494.93,111.12Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 383.69,
    y: 24.41,
    width: 1.62,
    height: 89.74
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.16,61c0,12.46-8.37,20.56-24.46,20.56H24.46v19.34H6.05V40.46H34.7C50.6,40.46,59.16,48.65,59.16,61Zm-18.79.56c0-4.09-2.88-6.23-6.33-6.23H24.46V67.62H34C37.49,67.62,40.37,65.58,40.37,61.58Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.3,55.35v8.37h21v14h-21V86h27.91v14.88H66.88V40.46h46.05V55.35Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.48,55.35v9.76h20.1v14h-20.1v21.85H123.07V40.46h45.39V55.35Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.63,70.69c0-17.95,14.51-31.34,33.76-31.34s33.77,13.39,33.77,31.34S224.65,102,205.39,102,171.63,88.65,171.63,70.69Zm48.74,0c0-8.65-6.7-14.79-15-14.79s-15,6.14-15,14.79,6.69,14.79,15,14.79S220.37,79.34,220.37,70.69Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.74,70.69c0-17.95,14.51-31.34,33.67-31.34A33,33,0,0,1,303.9,51v1.31l-11.16,9.48h-1.3a18.11,18.11,0,0,0-13.12-5.86,14.79,14.79,0,0,0,0,29.58,18.07,18.07,0,0,0,13.12-5.86h1.3l11.16,9.49v1.3C298.23,97.2,289.39,102,278.13,102,259.35,102,244.74,88.65,244.74,70.69Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.76,55.35v8.37h21v14h-21V86h27.91v14.88H311.35V40.46h46V55.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPefoceOrgao);
export default __webpack_public_path__ + "static/media/pefoce-orgao.8ffd0133505a338f5cd3ed84d848a765.svg";
export { ForwardRef as ReactComponent };